"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const General = {
    COOKIE_DOMAIN: process.env.COOKIE_DOMAIN || '.coindirect.com',
    COOKIE_NAME: process.env.COOKIE_NAME || 'cdCookie201805',
    COOKIE_NAME_IMPERSONATION: process.env.COOKIE_NAME_IMPERSONATE || 'otc-auth-impersonate',
    COOKIE_PERMANENT: process.env.COOKIE_PERMANENT || 'cdPrevious',
};
exports.default = General;
//# sourceMappingURL=General.js.map